import { getI18nLang } from '@yandex-int/i18n';

type TLang = 'ru' | 'en';

export const getTypedI18nLang = () => getI18nLang() as TLang;
